import { render, staticRenderFns } from "./title-with-title-display.vue?vue&type=template&id=0a28981f"
import script from "./title-with-title-display.vue?vue&type=script&lang=js"
export * from "./title-with-title-display.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports